import React, { useEffect, useRef, useState } from "react";
import Chart from "react-apexcharts";
import ApexCharts from "apexcharts";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { MdOpenInNew } from "react-icons/md";
import { getMonths } from "./helperMethods";

const AdViewsPerGameChart = ({ adViewPerGameData }) => {
  const area1Ref = useRef(null);
  useEffect(() => {
    if (adViewPerGameData?.length) {
      let months = getMonths();
      const seriesData = adViewPerGameData.map((game) => ({
        name: game?.title,
        data: game?.data?.map((month) => ({
          x: month.date,
          y: month.total_ads,
        })),
      }));

      window.Apex = {
        chart: { foreColor: "#ccc", toolbar: { show: false } },
        stroke: { width: 3 },
        dataLabels: { enabled: false },
        tooltip: { theme: "dark" },
        grid: { borderColor: "#535A6C", xaxis: { lines: { show: true } } },
      };

      const mountChart = (ref, options) => {
        const el = ref.current;
        if (el) {
          const chart = new ApexCharts(el, options);
          chart.render();
        }
      };

      const optionsArea = {
        chart: { height: 380, type: "area", stacked: false },
        stroke: { curve: "straight" },
        series: seriesData,

        xaxis: {
          categories: months,
        },
        tooltip: { followCursor: true },
        fill: { opacity: 1 },
      };
      mountChart(area1Ref, optionsArea);
    }
  }, [adViewPerGameData]);

  return (
    <div className="box shadow p-4 rounded cardBox text-light w-100 d-flex flex-column">
      <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center">
        <h5 className="card-title mb-2 mb-md-0">Ads Viewed Per Game</h5>
        <div className="d-flex align-items-center">
          <a
            href="/ad-view-count"
            className="text-decoration-none text-light me-2 d-flex align-items-center gap-2"
          >
            View All
            <MdOpenInNew className="fs-5" />
          </a>
        </div>
      </div>

      <div id="areachart1" ref={area1Ref} />
    </div>
  );
};

export default AdViewsPerGameChart;
